module.exports = __webpack_public_path__ + "static/img/03.997b8c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/03.jpg
// module id = YG0Q
// module chunks = 0